import list from 'src/modules/quiz/list/quizListReducers';
import form from 'src/modules/quiz/form/quizFormReducers';
import view from 'src/modules/quiz/view/quizViewReducers';
import destroy from 'src/modules/quiz/destroy/quizDestroyReducers';
import unarchive from 'src/modules/quiz/unarchive/quizUnarchiveReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  unarchive,
});
